/* eslint-disable no-unused-vars */
// *** Place your enums here ***

/**
 * Enum for the state of the stepper items
 */
export enum StepperState {
  CLOSED = "closed",
  DONE = "done",
  CURRENT = "current",
  PENDING = "pending",
  ERROR = "error",
}

/**
 * Enum for the form groups in the Create Tender form.
 * Values needs to be the same as the zod schema keys.
 */
export enum CreateTenderFormGroups {
  DOCUMENTS = "document",
  DESCRIPTION = "description",
  DEADLINES = "deadline",
  ESTIMATE = "estimate",
  CONTRACT = "contract",
  OPERATIONALORGANIZATION = "operationalOrganizationIds",
  ADDITIONAL = "additionalText",
  EXECUTIVESUMMARY = "executiveSummary",
  QUICK = "quick",
}

/**
 * Enum for the submit actions in the form.
 */
export enum SubmitAction {
  Add = "add",
  AddAndClose = "addAndClose",
}

export enum AiImportResponseTypes {
  PROGRESS = "PROGRESS",
  INFO = "INFO",
  ERROR = "ERROR",
  FINAL = "FINAL"
}

export enum AiImportResponseContent {
  INITIALIZING = "INITIALIZING", // Scanning and preparing uploaded files...
  PARSING = "PARSING", // Text and metadata extracted successfully
  CHUNKING = "CHUNKING", // Chunks created successfully
  INDEXING = "INDEXING", // Adding to knowledge base
  SUMMARY_GENERATION = "SUMMARY_GENERATION", // Executive summaries being generated
  SUMMARY_AGGREGATION = "SUMMARY_AGGREGATION", // Executive summaries completed
  DATA_EXTRACTION = "DATA_EXTRACTION", // Extracting data from documents
  WRITING_TO_DATABASE = "WRITING_TO_DATABASE", // Writing to database completed
  AI_IMPORT_COMPLETED = "AI_IMPORT_COMPLETED" // AI import completed
}

export enum ChunkMessage {
  TITLE = "title",
  START_MESSAGE = "startmessage",
  END_MESSAGE = "endmessage"
}

/**
 * Enum for the custom events in the chat SSE.
 */
export enum KarlCustomEvent {
  TOOL_CALL = "TOOL_CALL",
  REASONING = "REASONING",
  CHUNK = "CHUNK",
  DATA = "DATA",
  PROGRESS = "PROGRESS",
  FETCH_CONTEXT = "FETCH_CONTEXT",
};

export enum KarlEventContent {
  START = "START",
  FINISHED = "FINISHED",
  ANSWERING = "ANSWERING",
}

export enum KarlNodeRaw {
  QuestionGenerator = "questiongenerator",
  ContextRetriever = "contextretriever",
  AnswerQuestion = "answerquestion",
  FinalizeAnswer = "finalizeanswer",
  QuestionAnalyzer = "questionanalyzer",
}

/**
 * Enum for chat connection status
 */
export enum ChatStatus {
  IDLE = "idle",
  CONNECTING = "connecting",
  OPEN = "open",
  CLOSED = "closed",
  ERROR = "error",
}

/**
 * Enum for stream processing phase
 */
export enum StreamPhase {
  IDLE = "idle",
  THINKING = "thinking",
  ANSWERING = "answering",
  DONE = "done",
}

/**
 * Enum for processing node states
 */
export enum ProcessingNode {
  IDLE = "idle",
  QUESTION_ANALYZER = "QuestionAnalyzer",
  QUESTION_GENERATOR = "QuestionGenerator",
  CONTEXT_RETRIEVER = "ContextRetriever",
  ANSWER_QUESTION = "AnswerQuestion",
}

/**
 * Enum for tool call status
 */
export enum ToolCallStatus {
  RUNNING = "running",
  DONE = "done",
}

/**
 * Enum for Sheet Agent Help Dialog pages
 */
export enum SheetAgentHelpPage {
  OVERVIEW = 0,
  CREATE_RUN = 1,
  EDIT_TASKS = 2,
  DOWNLOAD_FILES = 3,
}
